/// <reference path="../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";

export interface SecretControlProps extends React.Props<SecretControl> {
    keyType: string;
    secret: string;
}

export interface SecretControlState {
    shown?: boolean;
}

export class SecretControl extends React.Component<SecretControlProps, SecretControlState> {

    constructor(props) {
        super(props);

        this.state = {
            shown: false
        };
    }

    private onToggleClick(event: React.MouseEvent<any>): void {
        this.setState({ shown: !this.state.shown });
    }

    public render(): JSX.Element {

        var regenStyle = {
            display: this.state.shown ? 'inline' : 'none'
        };

        var showStyle = {
            display: this.state.shown ? 'none' : 'inline'
        };

        return (
            <div className="secret-control">
                <input type={this.state.shown ? 'text' : 'password'} value={this.props.secret} spellCheck={false} />
                <a onClick={event => this.onToggleClick(event) } style={showStyle} >Show</a>
                <ul className="ul-vert-bar" style={regenStyle}>
                    <li><a onClick={event => this.onToggleClick(event) } >{this.state.shown ? 'Hide' : 'Show'}</a></li>
                    <li><a href="javascript:void(0)" className={'regenerate-link ' + this.props.keyType }>Regenerate</a></li>
                </ul>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./Client/Views/SecretControl.tsx